// Generated from nissei-backend origin/release a0947fa27ccd54f8492300d265bcb6a0bace5889.
// Regenerate with node scripts/generate-masterdata-contracts.cjs ../nissei-backend origin/release
import type { EntityContract } from './types';
export const BACKEND_COMMIT = 'a0947fa27ccd54f8492300d265bcb6a0bace5889';
export const contracts: EntityContract[] = [
  {
    id: 'alert-subscriptions',
    base: '/alert-subscriptions',
    currentOnly: false,
    create: [
      {
        name: 'alert_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'recipient_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'channel',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['EMAIL', 'IN_APP'],
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'is_active',
        kind: 'boolean',
        required: true,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'recipient_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'alert_type',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'alert_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'recipient_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'channel',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['EMAIL', 'IN_APP'],
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'alert_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'recipient_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'channel',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['EMAIL', 'IN_APP'],
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/alert-subscriptions',
      },
      {
        method: 'post',
        path: '/alert-subscriptions',
      },
      {
        method: 'get',
        path: '/alert-subscriptions/as-of',
      },
      {
        method: 'get',
        path: '/alert-subscriptions/:subscriptionId',
      },
      {
        method: 'patch',
        path: '/alert-subscriptions/:subscriptionId',
      },
    ],
    columns: [
      'id',
      'alert_type',
      'recipient_id',
      'recipient_code',
      'recipient_name',
      'channel',
      'is_active',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'asn-prerequisite-configurations',
    base: '/asn-prerequisite-configurations',
    currentOnly: false,
    create: [
      {
        name: 'certificate_submission_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'evidence_type',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'required_state',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['attachment_received', 'portal_submission_confirmed'],
      },
      {
        name: 'scope',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['shipment', 'lot', 'lot_and_order'],
      },
      {
        name: 'phase',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['pre_arrival', 'post_arrival'],
        defaultValue: 'pre_arrival',
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: false,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'is_active',
        kind: 'boolean',
        required: true,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'mapping_status',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['mapped', 'unmapped'],
      },
    ],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/asn-prerequisite-configurations',
      },
      {
        method: 'post',
        path: '/asn-prerequisite-configurations',
      },
      {
        method: 'get',
        path: '/asn-prerequisite-configurations/:configurationId',
      },
      {
        method: 'patch',
        path: '/asn-prerequisite-configurations/:configurationId',
      },
      {
        method: 'post',
        path: '/asn-prerequisite-configurations/:configurationId/revisions',
      },
    ],
    columns: [
      'id',
      'configuration_id',
      'revision',
      'mapping_status',
      'evidence_type_id',
      'evidence_type',
      'required_state',
      'scope',
      'phase',
      'mapping_note',
      'effective_from',
      'effective_to',
      'created_by',
      'created_at',
    ],
  },
  {
    id: 'batch-code-conversions',
    base: '/batch-code-conversions',
    currentOnly: false,
    create: [
      {
        name: 'code_value',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]$',
      },
      {
        name: 'month_number',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 1,
        max: 12,
      },
      {
        name: 'description',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    update: [
      {
        name: 'month_number',
        kind: 'number',
        required: false,
        nullable: false,
        integer: true,
        min: 1,
        max: 12,
      },
      {
        name: 'description',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['code_value', 'month_number', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/batch-code-conversions',
      },
      {
        method: 'post',
        path: '/batch-code-conversions',
      },
      {
        method: 'get',
        path: '/batch-code-conversions/:conversionId',
      },
      {
        method: 'patch',
        path: '/batch-code-conversions/:conversionId',
      },
    ],
    columns: [
      'id',
      'code_value',
      'month_number',
      'description',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'billing-settings',
    base: '/billing-settings',
    currentOnly: true,
    create: [
      {
        name: 'cycle',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['monthly_product', 'quarterly_tariff'],
        defaultValue: 'monthly_product',
      },
      {
        name: 'issue_date_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'billing_period_start_rule',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'billing_period_end_rule',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'invoice_number_pattern',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'entity_block',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'bank_block',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'payment_terms_text',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
      {
        name: 'due_day_rule',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'price_resolution_date_rule',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'tariff_issue_lag',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'billing_period_start_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'billing_period_end_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'invoice_number_pattern',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'entity_block',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'bank_block',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'payment_terms_text',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'due_day_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'price_resolution_date_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'issue_date_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'tariff_issue_lag',
        kind: 'number',
        required: false,
        nullable: false,
        integer: true,
        min: 0,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'cycle',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['monthly_product', 'quarterly_tariff'],
        defaultValue: 'monthly_product',
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'cycle',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['monthly_product', 'quarterly_tariff'],
        defaultValue: 'monthly_product',
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/billing-settings',
      },
      {
        method: 'post',
        path: '/billing-settings',
      },
      {
        method: 'get',
        path: '/billing-settings/as-of',
      },
      {
        method: 'get',
        path: '/billing-settings/history',
      },
      {
        method: 'get',
        path: '/billing-settings/:settingsId',
      },
      {
        method: 'patch',
        path: '/billing-settings/:settingsId',
      },
    ],
    columns: [
      'id',
      'cycle',
      'billing_period_start_rule',
      'billing_period_end_rule',
      'invoice_number_pattern',
      'entity_block',
      'bank_block',
      'payment_terms_text',
      'due_day_rule',
      'price_resolution_date_rule',
      'issue_date_rule',
      'tariff_issue_lag',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'business-settings',
    base: '/business-settings',
    currentOnly: true,
    create: [
      {
        name: 'backdate_reason',
        kind: 'text',
        required: false,
        nullable: false,
        min: 10,
        max: 500,
      },
      {
        name: 'setting_key',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'setting_value',
        kind: 'text',
        required: true,
        nullable: false,
      },
      {
        name: 'value_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'module_scope',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'description',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'setting_value',
        kind: 'text',
        required: false,
        nullable: false,
      },
      {
        name: 'value_type',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'module_scope',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'description',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
    ],
    filters: [
      {
        name: 'module_scope',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'setting_key',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'setting_key',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/business-settings',
      },
      {
        method: 'post',
        path: '/business-settings',
      },
      {
        method: 'get',
        path: '/business-settings/as-of',
      },
      {
        method: 'get',
        path: '/business-settings/history/:settingKey',
      },
      {
        method: 'get',
        path: '/business-settings/:settingId',
      },
      {
        method: 'patch',
        path: '/business-settings/:settingId',
      },
    ],
    columns: [
      'id',
      'setting_key',
      'setting_value',
      'value_type',
      'module_scope',
      'description',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'calculation-rules',
    base: '/calculation-rules',
    currentOnly: true,
    create: [
      {
        name: 'rule_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'rule_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'rule_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['derived_value', 'derived_identifier'],
      },
      {
        name: 'formula_text',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
      {
        name: 'rounding_rule',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['whole_yen', 'dollar_half_up_cent', 'exact_required_reject_fraction', 'n/a'],
      },
      {
        name: 'parameter_refs',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
      {
        name: 'applies_forward_only',
        kind: 'boolean',
        required: false,
        nullable: false,
        defaultValue: true,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'rule_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'formula_text',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'rounding_rule',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['whole_yen', 'dollar_half_up_cent', 'exact_required_reject_fraction', 'n/a'],
      },
      {
        name: 'parameter_refs',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
      {
        name: 'applies_forward_only',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'rule_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['derived_value', 'derived_identifier'],
      },
    ],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'rule_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'rule_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/calculation-rules',
      },
      {
        method: 'post',
        path: '/calculation-rules',
      },
      {
        method: 'get',
        path: '/calculation-rules/as-of',
      },
      {
        method: 'get',
        path: '/calculation-rules/history/:ruleCode',
      },
      {
        method: 'get',
        path: '/calculation-rules/:ruleId',
      },
      {
        method: 'patch',
        path: '/calculation-rules/:ruleId',
      },
    ],
    columns: [
      'id',
      'rule_code',
      'rule_name',
      'rule_type',
      'implementation_status',
      'implementation_note',
      'formula_text',
      'rounding_rule',
      'parameter_refs',
      'applies_forward_only',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'carriers',
    base: '/carriers',
    currentOnly: true,
    create: [
      {
        name: 'carrier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'carrier_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'carrier_type',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'contact_details',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
      {
        name: 'tracking_reference_format',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'carrier_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'carrier_type',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'contact_details',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
      },
      {
        name: 'tracking_reference_format',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['carrier_code', 'carrier_name', 'updated_at'],
    paginated: true,
    asOf: [
      {
        name: 'carrier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'carrier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/carriers',
      },
      {
        method: 'post',
        path: '/carriers',
      },
      {
        method: 'get',
        path: '/carriers/as-of',
      },
      {
        method: 'get',
        path: '/carriers/history/:carrierCode',
      },
      {
        method: 'get',
        path: '/carriers/:carrierId',
      },
      {
        method: 'patch',
        path: '/carriers/:carrierId',
      },
    ],
    columns: [
      'id',
      'carrier_code',
      'carrier_name',
      'carrier_type',
      'contact_details',
      'tracking_reference_format',
      'is_active',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'currencies',
    base: '/currencies',
    currentOnly: false,
    create: [
      {
        name: 'currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'currency_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'symbol',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 10,
      },
      {
        name: 'decimal_places',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
      },
    ],
    update: [
      {
        name: 'currency_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'symbol',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 10,
      },
      {
        name: 'decimal_places',
        kind: 'number',
        required: false,
        nullable: false,
        integer: true,
        min: 0,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['currency_code', 'currency_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/currencies',
      },
      {
        method: 'post',
        path: '/currencies',
      },
      {
        method: 'get',
        path: '/currencies/:currencyId',
      },
      {
        method: 'patch',
        path: '/currencies/:currencyId',
      },
    ],
    columns: [
      'id',
      'currency_code',
      'currency_name',
      'symbol',
      'decimal_places',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'customer-sites',
    base: '/customer-sites',
    currentOnly: false,
    create: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'site_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'site_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'site_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['site_code', 'site_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/customer-sites',
      },
      {
        method: 'post',
        path: '/customer-sites',
      },
      {
        method: 'get',
        path: '/customer-sites/:siteId',
      },
      {
        method: 'patch',
        path: '/customer-sites/:siteId',
      },
    ],
    columns: [
      'id',
      'customer_id',
      'customer_code',
      'customer_name',
      'site_code',
      'site_name',
      'location_id',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'customers',
    base: '/customers',
    currentOnly: false,
    create: [
      {
        name: 'customer_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'customer_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    update: [
      {
        name: 'customer_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['customer_code', 'customer_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/customers',
      },
      {
        method: 'post',
        path: '/customers',
      },
      {
        method: 'get',
        path: '/customers/:customerId',
      },
      {
        method: 'patch',
        path: '/customers/:customerId',
      },
    ],
    columns: ['id', 'customer_code', 'customer_name', 'is_active', 'created_at', 'updated_at'],
  },
  {
    id: 'document-origin-countries',
    base: '/document-origin-countries',
    currentOnly: false,
    create: [],
    update: [],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/document-origin-countries',
      },
      {
        method: 'post',
        path: '/document-origin-countries',
      },
      {
        method: 'delete',
        path: '/document-origin-countries/:country',
      },
    ],
    columns: [],
  },
  {
    id: 'document-settings',
    base: '/document-settings',
    currentOnly: true,
    create: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'origin',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'numbering_pattern',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'filename_pattern',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'field_selection',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
      {
        name: 'standing_texts',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'template_version',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'numbering_pattern',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'filename_pattern',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'field_selection',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'standing_texts',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'template_version',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    filters: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'origin',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'origin',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'origin',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/document-settings',
      },
      {
        method: 'post',
        path: '/document-settings',
      },
      {
        method: 'get',
        path: '/document-settings/as-of',
      },
      {
        method: 'get',
        path: '/document-settings/history',
      },
      {
        method: 'get',
        path: '/document-settings/:documentSettingId',
      },
      {
        method: 'patch',
        path: '/document-settings/:documentSettingId',
      },
    ],
    columns: [
      'id',
      'document_type_id',
      'document_type_code',
      'document_name',
      'origin',
      'numbering_pattern',
      'filename_pattern',
      'field_selection',
      'standing_texts',
      'template_version',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'document-signing-authorities',
    base: '/document-signing-authorities',
    currentOnly: false,
    create: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'permitted_role',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
      {
        name: 'signer_employee_id',
        kind: 'reference',
        required: false,
        nullable: true,
      },
      {
        name: 'authorized_by',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'is_active',
        kind: 'boolean',
        required: true,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
    ],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/document-signing-authorities',
      },
      {
        method: 'post',
        path: '/document-signing-authorities',
      },
      {
        method: 'get',
        path: '/document-signing-authorities/:documentSigningAuthorityId',
      },
      {
        method: 'patch',
        path: '/document-signing-authorities/:documentSigningAuthorityId',
      },
    ],
    columns: [
      'id',
      'document_type_id',
      'document_type_code',
      'document_name',
      'permitted_role',
      'signer_employee_id',
      'signer_employee_code',
      'signer_employee_name',
      'authorized_by',
      'authorized_by_employee_code',
      'authorized_by_employee_name',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'document-types',
    base: '/document-types',
    currentOnly: false,
    create: [
      {
        name: 'document_type_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'document_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'category',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'evidence_phase',
        kind: 'enum',
        required: false,
        nullable: true,
        options: ['pre_arrival', 'post_arrival'],
      },
      {
        name: 'evidence_requires_milestone',
        kind: 'text',
        required: false,
        nullable: true,
      },
      {
        name: 'evidence_depends_on',
        kind: 'text',
        required: false,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'document_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'category',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
      {
        name: 'evidence_phase',
        kind: 'enum',
        required: false,
        nullable: true,
        options: ['pre_arrival', 'post_arrival'],
      },
      {
        name: 'evidence_requires_milestone',
        kind: 'text',
        required: false,
        nullable: true,
      },
      {
        name: 'evidence_depends_on',
        kind: 'text',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'category',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['document_type_code', 'document_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/document-types',
      },
      {
        method: 'post',
        path: '/document-types',
      },
      {
        method: 'get',
        path: '/document-types/:documentTypeId',
      },
      {
        method: 'patch',
        path: '/document-types/:documentTypeId',
      },
    ],
    columns: [
      'id',
      'document_type_code',
      'document_name',
      'category',
      'is_active',
      'evidence_phase',
      'evidence_requires_milestone',
      'evidence_depends_on',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'employees',
    base: '/employees',
    currentOnly: false,
    create: [
      {
        name: 'employee_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'employee_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'email',
        kind: 'email',
        required: true,
        nullable: false,
        max: 320,
      },
      {
        name: 'job_title',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 200,
      },
    ],
    update: [
      {
        name: 'employee_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'email',
        kind: 'email',
        required: false,
        nullable: false,
        max: 320,
      },
      {
        name: 'job_title',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 200,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'location',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['employee_code', 'employee_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/employees',
      },
      {
        method: 'post',
        path: '/employees',
      },
      {
        method: 'get',
        path: '/employees/:employeeId',
      },
      {
        method: 'patch',
        path: '/employees/:employeeId',
      },
      {
        method: 'get',
        path: '/employees/:id/account',
      },
      {
        method: 'post',
        path: '/employees/:id/account',
      },
    ],
    columns: [
      'id',
      'employee_code',
      'employee_name',
      'email',
      'job_title',
      'location',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'exchange-rates',
    base: '/exchange-rates',
    currentOnly: false,
    create: [
      {
        name: 'from_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'to_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'rate',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'source',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'rate',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'source',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    filters: [
      {
        name: 'from_currency_code',
        kind: 'text',
        required: false,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'to_currency_code',
        kind: 'text',
        required: false,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
    ],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'from_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'to_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'from_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
      {
        name: 'to_currency_code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z]{3}$',
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/exchange-rates',
      },
      {
        method: 'post',
        path: '/exchange-rates',
      },
      {
        method: 'get',
        path: '/exchange-rates/as-of',
      },
      {
        method: 'get',
        path: '/exchange-rates/:rateId',
      },
      {
        method: 'patch',
        path: '/exchange-rates/:rateId',
      },
      {
        method: 'delete',
        path: '/exchange-rates/:rateId',
      },
    ],
    columns: [
      'id',
      'from_currency_id',
      'from_currency_code',
      'to_currency_id',
      'to_currency_code',
      'rate',
      'source',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'fab-phases',
    base: '/fab-phases',
    currentOnly: false,
    create: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'phase_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    update: [],
    filters: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/fab-phases',
      },
      {
        method: 'post',
        path: '/fab-phases',
      },
      {
        method: 'get',
        path: '/fab-phases/:fabPhaseId',
      },
    ],
    columns: [
      'id',
      'customer_id',
      'customer_code',
      'customer_name',
      'phase_code',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'factories',
    base: '/factories',
    currentOnly: false,
    create: [
      {
        name: 'factory_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'factory_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'factory_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['factory_code', 'factory_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/factories',
      },
      {
        method: 'post',
        path: '/factories',
      },
      {
        method: 'get',
        path: '/factories/:factoryId',
      },
      {
        method: 'patch',
        path: '/factories/:factoryId',
      },
    ],
    columns: [
      'id',
      'factory_code',
      'factory_name',
      'location_id',
      'location_code',
      'location_name',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'inventory-planning-settings',
    base: '/inventory-planning-settings',
    currentOnly: true,
    create: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'inventory_floor_days',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'maximum_inventory_days',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'usage_lookback_period',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'forecast_divergence_threshold_percent',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'inventory_floor_days',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'maximum_inventory_days',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'usage_lookback_period',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'forecast_divergence_threshold_percent',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/inventory-planning-settings',
      },
      {
        method: 'post',
        path: '/inventory-planning-settings',
      },
      {
        method: 'get',
        path: '/inventory-planning-settings/as-of',
      },
      {
        method: 'get',
        path: '/inventory-planning-settings/history/:productId',
      },
      {
        method: 'get',
        path: '/inventory-planning-settings/:settingsId',
      },
      {
        method: 'patch',
        path: '/inventory-planning-settings/:settingsId',
      },
    ],
    columns: [
      'id',
      'product_id',
      'product_code',
      'product_name',
      'inventory_floor_days',
      'maximum_inventory_days',
      'usage_lookback_period',
      'forecast_divergence_threshold_percent',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'locations',
    base: '/locations',
    currentOnly: false,
    create: [
      {
        name: 'location_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'location_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['plant', 'warehouse', 'customer_site', 'hub', 'port_of_entry'],
      },
      {
        name: 'address',
        kind: 'text',
        required: false,
        nullable: true,
        max: 500,
      },
      {
        name: 'city',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
      {
        name: 'state_region',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
      {
        name: 'postal_code',
        kind: 'text',
        required: false,
        nullable: true,
        max: 20,
      },
      {
        name: 'country',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
    ],
    update: [
      {
        name: 'location_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['plant', 'warehouse', 'customer_site', 'hub', 'port_of_entry'],
      },
      {
        name: 'address',
        kind: 'text',
        required: false,
        nullable: true,
        max: 500,
      },
      {
        name: 'city',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
      {
        name: 'state_region',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
      {
        name: 'postal_code',
        kind: 'text',
        required: false,
        nullable: true,
        max: 20,
      },
      {
        name: 'country',
        kind: 'text',
        required: false,
        nullable: true,
        max: 100,
      },
    ],
    filters: [
      {
        name: 'location_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['plant', 'warehouse', 'customer_site', 'hub', 'port_of_entry'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['location_code', 'location_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/locations',
      },
      {
        method: 'post',
        path: '/locations',
      },
      {
        method: 'get',
        path: '/locations/:locationId',
      },
      {
        method: 'patch',
        path: '/locations/:locationId',
      },
    ],
    columns: [
      'id',
      'location_code',
      'location_name',
      'location_type',
      'address',
      'city',
      'state_region',
      'postal_code',
      'country',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'logger-recorder-configurations',
    base: '/logger-recorder-configurations',
    currentOnly: true,
    create: [
      {
        name: 'recorder_model',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'file_layout',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'reading_uom',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'interval_tolerance_minutes',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        max: 999.99,
      },
      {
        name: 'logging_interval',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'expected_min_recorders_per_shipment',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 2,
      },
      {
        name: 'recorders_per_box',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
      },
      {
        name: 'boxes_with_recorders',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'placement_priority',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'applicability',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'file_layout',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'reading_uom',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'logging_interval',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'expected_min_recorders_per_shipment',
        kind: 'number',
        required: false,
        nullable: false,
        integer: true,
        min: 2,
      },
      {
        name: 'recorders_per_box',
        kind: 'number',
        required: false,
        nullable: false,
        integer: true,
        min: 0,
      },
      {
        name: 'boxes_with_recorders',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'placement_priority',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'applicability',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'recorder_model',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'recorder_model',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/logger-recorder-configurations',
      },
      {
        method: 'post',
        path: '/logger-recorder-configurations',
      },
      {
        method: 'get',
        path: '/logger-recorder-configurations/as-of',
      },
      {
        method: 'get',
        path: '/logger-recorder-configurations/history/:recorderModel',
      },
      {
        method: 'get',
        path: '/logger-recorder-configurations/:configurationId',
      },
      {
        method: 'patch',
        path: '/logger-recorder-configurations/:configurationId',
      },
    ],
    columns: [
      'id',
      'recorder_model',
      'file_layout',
      'reading_uom',
      'interval_tolerance_minutes',
      'logging_interval',
      'expected_min_recorders_per_shipment',
      'recorders_per_box',
      'boxes_with_recorders',
      'placement_priority',
      'applicability',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'payment-calendars',
    base: '/payment-calendars',
    currentOnly: false,
    create: [
      {
        name: 'country',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'non_working_date',
        kind: 'date',
        required: true,
        nullable: false,
      },
      {
        name: 'working_day_pattern',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'description',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    update: [
      {
        name: 'non_working_date',
        kind: 'date',
        required: false,
        nullable: false,
      },
      {
        name: 'working_day_pattern',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'description',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    filters: [
      {
        name: 'country',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'calendar_year',
        kind: 'number',
        required: false,
        nullable: true,
        integer: true,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/payment-calendars',
      },
      {
        method: 'post',
        path: '/payment-calendars',
      },
      {
        method: 'get',
        path: '/payment-calendars/:entryId',
      },
      {
        method: 'patch',
        path: '/payment-calendars/:entryId',
      },
    ],
    columns: [
      'id',
      'country',
      'calendar_year',
      'working_day_pattern',
      'non_working_date',
      'description',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'payment-terms',
    base: '/payment-terms',
    currentOnly: true,
    create: [
      {
        name: 'term_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'description',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      { name: 'base_date', kind: 'enum', required: false, nullable: true, options: ['bl_date', 'invoice_date'] },
      {
        name: 'due_days',
        kind: 'number',
        required: false,
        nullable: true,
        integer: true,
        min: 0,
        max: 3650,
      },
      {
        name: 'due_date_rule',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'description',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      { name: 'base_date', kind: 'enum', required: false, nullable: true, options: ['bl_date', 'invoice_date'] },
      {
        name: 'due_days',
        kind: 'number',
        required: false,
        nullable: true,
        integer: true,
        min: 0,
        max: 3650,
      },
      {
        name: 'due_date_rule',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'term_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'term_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/payment-terms',
      },
      {
        method: 'post',
        path: '/payment-terms',
      },
      {
        method: 'get',
        path: '/payment-terms/as-of',
      },
      {
        method: 'get',
        path: '/payment-terms/history/:termCode',
      },
      {
        method: 'get',
        path: '/payment-terms/:termId',
      },
      {
        method: 'patch',
        path: '/payment-terms/:termId',
      },
    ],
    columns: [
      'id',
      'term_code',
      'description',
      'due_date_rule',
      'due_days',
      'base_date',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'plant-storage-locations',
    base: '/plant-storage-locations',
    currentOnly: false,
    create: [],
    update: [],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/plant-storage-locations/unmapped',
      },
      {
        method: 'get',
        path: '/plant-storage-locations',
      },
      {
        method: 'post',
        path: '/plant-storage-locations',
      },
    ],
    columns: [],
  },
  {
    id: 'product-information-records',
    base: '/product-information-records',
    currentOnly: true,
    create: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'record_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['SOURCE', 'WORKING'],
      },
      {
        name: 'source',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'effective_date',
        kind: 'date',
        required: true,
        nullable: false,
      },
      {
        name: 'revision_flag',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
      {
        name: 'revision_reason',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
    ],
    update: [
      {
        name: 'source',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'revision_flag',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
      {
        name: 'revision_reason',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'product_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'record_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['SOURCE', 'WORKING'],
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'record_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['SOURCE', 'WORKING'],
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'record_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['SOURCE', 'WORKING'],
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/product-information-records',
      },
      {
        method: 'post',
        path: '/product-information-records',
      },
      {
        method: 'get',
        path: '/product-information-records/as-of',
      },
      {
        method: 'get',
        path: '/product-information-records/history',
      },
      {
        method: 'get',
        path: '/product-information-records/:recordId',
      },
      {
        method: 'patch',
        path: '/product-information-records/:recordId',
      },
    ],
    columns: [
      'id',
      'product_id',
      'product_code',
      'product_name',
      'record_type',
      'source',
      'effective_date',
      'revision_flag',
      'revision_reason',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'product-lifecycle-parameters',
    base: '/product-lifecycle-parameters',
    currentOnly: true,
    create: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'shelf_life_duration',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'ship_by_duration',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'deliver_by_duration',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'duration_uom',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'shelf_life_duration',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'ship_by_duration',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'deliver_by_duration',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'duration_uom',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 20,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/product-lifecycle-parameters',
      },
      {
        method: 'post',
        path: '/product-lifecycle-parameters',
      },
      {
        method: 'get',
        path: '/product-lifecycle-parameters/as-of',
      },
      {
        method: 'get',
        path: '/product-lifecycle-parameters/history/:productId',
      },
      {
        method: 'get',
        path: '/product-lifecycle-parameters/:parametersId',
      },
      {
        method: 'patch',
        path: '/product-lifecycle-parameters/:parametersId',
      },
    ],
    columns: [
      'id',
      'product_id',
      'product_code',
      'product_name',
      'shelf_life_duration',
      'ship_by_duration',
      'deliver_by_duration',
      'duration_uom',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'product-prices',
    base: '/product-prices',
    currentOnly: false,
    create: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'price_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['BUY', 'SELL'],
      },
      {
        name: 'supplier_code',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 50,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: true,
      },
      {
        name: 'issuing_entity',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'amount',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'currency_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
      {
        name: 'entered_by',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'issuing_entity',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'amount',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
    ],
    filters: [
      {
        name: 'product_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'customer_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'price_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['BUY', 'SELL'],
      },
      {
        name: 'supplier_code',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'approval_status',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['pending', 'approved', 'rejected'],
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'price_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['BUY', 'SELL'],
      },
      {
        name: 'supplier_code',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'price_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['BUY', 'SELL'],
      },
      {
        name: 'supplier_code',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/product-prices',
      },
      {
        method: 'post',
        path: '/product-prices',
      },
      {
        method: 'get',
        path: '/product-prices/as-of',
      },
      {
        method: 'get',
        path: '/product-prices/history',
      },
      {
        method: 'get',
        path: '/product-prices/:priceId',
      },
      {
        method: 'patch',
        path: '/product-prices/:priceId',
      },
      {
        method: 'post',
        path: '/product-prices/:priceId/decision',
      },
    ],
    columns: [
      'id',
      'product_id',
      'product_code',
      'product_name',
      'customer_id',
      'customer_code',
      'customer_name',
      'location_id',
      'location_code',
      'location_name',
      'price_type',
      'supplier_code',
      'supplier_name',
      'factory_id',
      'factory_code',
      'factory_name',
      'issuing_entity',
      'amount',
      'currency_id',
      'currency_code',
      'effective_from',
      'effective_to',
      'entered_by',
      'entered_by_code',
      'approved_by',
      'approved_by_code',
      'approval_status',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'product-tariff-classifications',
    base: '/product-tariff-classifications',
    currentOnly: false,
    create: [
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'tariff_classification',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'special_tariff_classification',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 50,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
      {
        name: 'backdate_reason',
        kind: 'text',
        required: false,
        nullable: false,
        min: 10,
        max: 500,
      },
    ],
    update: [],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/product-tariff-classifications',
      },
      {
        method: 'post',
        path: '/product-tariff-classifications',
      },
      {
        method: 'get',
        path: '/product-tariff-classifications/as-of',
      },
      {
        method: 'get',
        path: '/product-tariff-classifications/history/:productId',
      },
      {
        method: 'get',
        path: '/product-tariff-classifications/:parametersId',
      },
      {
        method: 'patch',
        path: '/product-tariff-classifications/:parametersId',
      },
    ],
    columns: [
      'id',
      'product_id',
      'product_code',
      'product_name',
      'tariff_classification',
      'special_tariff_classification',
      'effective_from',
      'effective_to',
      'created_by',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'retention-policies',
    base: '/retention-policies',
    currentOnly: true,
    create: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'retention_period',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'retention_unit',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'archival_rule',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'disposal_rule',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'retention_period',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'retention_unit',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'archival_rule',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
      {
        name: 'disposal_rule',
        kind: 'text',
        required: false,
        nullable: true,
        max: 10000,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'document_type_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/retention-policies',
      },
      {
        method: 'post',
        path: '/retention-policies',
      },
      {
        method: 'get',
        path: '/retention-policies/as-of',
      },
      {
        method: 'get',
        path: '/retention-policies/history/:documentTypeId',
      },
      {
        method: 'get',
        path: '/retention-policies/:retentionPolicyId',
      },
      {
        method: 'patch',
        path: '/retention-policies/:retentionPolicyId',
      },
    ],
    columns: [
      'id',
      'document_type_id',
      'document_type_code',
      'document_name',
      'retention_period',
      'retention_unit',
      'archival_rule',
      'disposal_rule',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'route-legs',
    base: '/route-legs',
    currentOnly: true,
    create: [
      {
        name: 'route_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'leg_sequence',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'origin_location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'destination_location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'transit_duration',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'duration_uom',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['day', 'days', 'd', 'hour', 'hours', 'h', 'hr', 'hrs'],
      },
      {
        name: 'shipment_capacity_limit',
        kind: 'number',
        required: false,
        nullable: true,
        min: 0,
      },
      {
        name: 'monthly_capacity_limit',
        kind: 'number',
        required: false,
        nullable: true,
        min: 0,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'origin_location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'destination_location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'transit_duration',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'duration_uom',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['day', 'days', 'd', 'hour', 'hours', 'h', 'hr', 'hrs'],
      },
      {
        name: 'shipment_capacity_limit',
        kind: 'number',
        required: false,
        nullable: true,
        min: 0,
      },
      {
        name: 'monthly_capacity_limit',
        kind: 'number',
        required: false,
        nullable: true,
        min: 0,
      },
    ],
    filters: [
      {
        name: 'route_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'route_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'leg_sequence',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
        exclusiveMin: true,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    history: [
      {
        name: 'transport_mode',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'route_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'leg_sequence',
        kind: 'number',
        required: true,
        nullable: false,
        integer: true,
        min: 0,
        exclusiveMin: true,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/route-legs',
      },
      {
        method: 'post',
        path: '/route-legs',
      },
      {
        method: 'get',
        path: '/route-legs/as-of',
      },
      {
        method: 'get',
        path: '/route-legs/history',
      },
      {
        method: 'get',
        path: '/route-legs/:routeLegId',
      },
      {
        method: 'patch',
        path: '/route-legs/:routeLegId',
      },
    ],
    columns: [
      'id',
      'route_id',
      'route_code',
      'route_name',
      'leg_sequence',
      'origin_location_id',
      'origin_location_code',
      'origin_location_name',
      'destination_location_id',
      'destination_location_code',
      'destination_location_name',
      'transport_mode',
      'transit_duration',
      'duration_uom',
      'shipment_capacity_limit',
      'monthly_capacity_limit',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'storage-room-assignments',
    base: '/products/:productId/storage-room-assignments',
    currentOnly: false,
    create: [
      {
        name: 'storage_room_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'storage_room_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'post',
        path: '/products/:productId/storage-room-assignments',
      },
      {
        method: 'get',
        path: '/products/:productId/storage-room-assignments',
      },
      {
        method: 'patch',
        path: '/products/:productId/storage-room-assignments/:assignmentId',
      },
    ],
    columns: [
      'id',
      'product_id',
      'storage_room_id',
      'room_code',
      'room_name',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'storage-rooms',
    base: '/storage-rooms',
    currentOnly: false,
    create: [
      {
        name: 'factory_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'room_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'room_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'room_type',
        kind: 'enum',
        required: true,
        nullable: false,
        options: ['freeze', 'cool', 'room_temperature'],
      },
    ],
    update: [
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'room_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'room_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['freeze', 'cool', 'room_temperature'],
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'room_type',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['freeze', 'cool', 'room_temperature'],
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['room_code', 'room_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/storage-rooms',
      },
      {
        method: 'post',
        path: '/storage-rooms',
      },
      {
        method: 'get',
        path: '/storage-rooms/:storageRoomId',
      },
      {
        method: 'patch',
        path: '/storage-rooms/:storageRoomId',
      },
    ],
    columns: [
      'id',
      'factory_id',
      'factory_code',
      'factory_name',
      'room_code',
      'room_name',
      'room_type',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'suppliers',
    base: '/suppliers',
    currentOnly: true,
    create: [
      {
        name: 'supplier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'supplier_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'incoterm',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'payment_terms_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'supplier_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'incoterm',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 20,
      },
      {
        name: 'payment_terms_code',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['supplier_code', 'supplier_name', 'updated_at'],
    paginated: true,
    asOf: [
      {
        name: 'supplier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'supplier_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/suppliers',
      },
      {
        method: 'post',
        path: '/suppliers',
      },
      {
        method: 'get',
        path: '/suppliers/as-of',
      },
      {
        method: 'get',
        path: '/suppliers/history/:supplierCode',
      },
      {
        method: 'get',
        path: '/suppliers/:supplierId',
      },
      {
        method: 'patch',
        path: '/suppliers/:supplierId',
      },
    ],
    columns: [
      'id',
      'supplier_code',
      'supplier_name',
      'location_id',
      'location_code',
      'location_name',
      'incoterm',
      'payment_terms_code',
      'is_active',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'supply-routes',
    base: '/supply-routes',
    currentOnly: false,
    create: [
      {
        name: 'delivery_mode',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['warehouse', 'direct'],
      },
      {
        name: 'arrival_location_id',
        kind: 'reference',
        required: false,
        nullable: true,
      },
      {
        name: 'route_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'route_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'origin_location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'destination_location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    update: [
      {
        name: 'delivery_mode',
        kind: 'enum',
        required: false,
        nullable: true,
        options: ['warehouse', 'direct'],
      },
      {
        name: 'arrival_location_id',
        kind: 'reference',
        required: false,
        nullable: true,
      },
      {
        name: 'route_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'origin_location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'destination_location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'transport_mode',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'factory_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['route_code', 'route_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/supply-routes',
      },
      {
        method: 'post',
        path: '/supply-routes',
      },
      {
        method: 'get',
        path: '/supply-routes/:routeId',
      },
      {
        method: 'patch',
        path: '/supply-routes/:routeId',
      },
    ],
    columns: [
      'delivery_mode',
      'arrival_location_id',
      'id',
      'route_code',
      'route_name',
      'origin_location_id',
      'origin_location_code',
      'origin_location_name',
      'destination_location_id',
      'destination_location_code',
      'destination_location_name',
      'factory_id',
      'factory_code',
      'factory_name',
      'transport_mode',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'tariff-rates',
    base: '/tariff-rates',
    currentOnly: true,
    create: [
      {
        name: 'tariff_classification',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'tariff_rate',
        kind: 'number',
        required: true,
        nullable: false,
        min: 0,
      },
      {
        name: 'source',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'recoverable_from_customer',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'tariff_rate',
        kind: 'number',
        required: false,
        nullable: false,
        min: 0,
      },
      {
        name: 'source',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'recoverable_from_customer',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [
      {
        name: 'tariff_classification',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'tariff_classification',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/tariff-rates',
      },
      {
        method: 'post',
        path: '/tariff-rates',
      },
      {
        method: 'get',
        path: '/tariff-rates/as-of',
      },
      {
        method: 'get',
        path: '/tariff-rates/history/:tariffClassification',
      },
      {
        method: 'get',
        path: '/tariff-rates/:rateId',
      },
      {
        method: 'patch',
        path: '/tariff-rates/:rateId',
      },
    ],
    columns: [
      'id',
      'tariff_classification',
      'tariff_rate',
      'source',
      'recoverable_from_customer',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'tax-exemptions',
    base: '/tax-exemptions',
    currentOnly: true,
    create: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: true,
      },
      {
        name: 'tax_exempt',
        kind: 'boolean',
        required: true,
        nullable: false,
      },
      {
        name: 'exemption_basis',
        kind: 'enum',
        required: false,
        nullable: true,
        options: ['certificate', 'export'],
      },
      {
        name: 'exemption_certificate_reference',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
      {
        name: 'effective_from',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    update: [
      {
        name: 'tax_exempt',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
      {
        name: 'exemption_basis',
        kind: 'enum',
        required: false,
        nullable: true,
        options: ['certificate', 'export'],
      },
      {
        name: 'exemption_certificate_reference',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
    ],
    filters: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'product_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'date',
        kind: 'date',
        required: true,
        nullable: false,
      },
    ],
    history: [
      {
        name: 'customer_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'product_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
    ],
    routes: [
      {
        method: 'get',
        path: '/tax-exemptions',
      },
      {
        method: 'post',
        path: '/tax-exemptions',
      },
      {
        method: 'get',
        path: '/tax-exemptions/as-of',
      },
      {
        method: 'get',
        path: '/tax-exemptions/history',
      },
      {
        method: 'get',
        path: '/tax-exemptions/:taxExemptionId',
      },
      {
        method: 'patch',
        path: '/tax-exemptions/:taxExemptionId',
      },
    ],
    columns: [
      'id',
      'customer_id',
      'customer_code',
      'customer_name',
      'product_id',
      'product_code',
      'product_name',
      'location_id',
      'location_code',
      'location_name',
      'tax_exempt',
      'exemption_basis',
      'exemption_certificate_reference',
      'effective_from',
      'effective_to',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'transport-modes',
    base: '/transport-modes',
    currentOnly: false,
    create: [],
    update: [],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/transport-modes',
      },
      {
        method: 'post',
        path: '/transport-modes',
      },
      {
        method: 'post',
        path: '/transport-modes/:code/deactivate',
      },
      {
        method: 'patch',
        path: '/transport-modes/:code',
      },
      {
        method: 'post',
        path: '/transport-modes/:code/activate',
      },
    ],
    columns: [],
  },
  {
    id: 'uoms',
    base: '/uoms',
    currentOnly: false,
    create: [
      {
        name: 'code',
        kind: 'text',
        required: true,
        nullable: false,
        uppercase: true,
        pattern: '^[A-Z][A-Z0-9_-]{0,19}$',
      },
      {
        name: 'display_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    update: [
      {
        name: 'display_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    filters: [],
    sort: [],
    paginated: false,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/uoms',
      },
      {
        method: 'post',
        path: '/uoms',
      },
      {
        method: 'get',
        path: '/uoms/:uomId',
      },
      {
        method: 'patch',
        path: '/uoms/:uomId',
      },
      {
        method: 'delete',
        path: '/uoms/:uomId',
      },
    ],
    columns: ['id', 'code', 'display_name', 'created_at', 'updated_at'],
  },
  {
    id: 'validation-rules',
    base: '/validation-rules',
    currentOnly: false,
    create: [
      {
        name: 'rule_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'rule_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'condition_text',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
      {
        name: 'applies_to_context',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'responsible_role',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'rejection_message_template',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
    ],
    update: [
      {
        name: 'rule_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'condition_text',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'applies_to_context',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'responsible_role',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
      {
        name: 'rejection_message_template',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
    ],
    filters: [
      {
        name: 'applies_to_context',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
    ],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/validation-rules',
      },
      {
        method: 'post',
        path: '/validation-rules',
      },
      {
        method: 'get',
        path: '/validation-rules/:ruleId',
      },
      {
        method: 'patch',
        path: '/validation-rules/:ruleId',
      },
      {
        method: 'post',
        path: '/validation-rules/:ruleId/confirm',
      },
    ],
    columns: [
      'id',
      'rule_code',
      'rule_name',
      'condition_text',
      'applies_to_context',
      'responsible_role',
      'rejection_message_template',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'warehouse-storage-bins',
    base: '/warehouse-storage-bins',
    currentOnly: false,
    create: [
      {
        name: 'warehouse_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'bin_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'bin_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'zone_bin_type',
        kind: 'text',
        required: false,
        nullable: true,
        max: 50,
      },
    ],
    update: [
      {
        name: 'warehouse_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'bin_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'zone_bin_type',
        kind: 'text',
        required: false,
        nullable: true,
        max: 50,
      },
    ],
    filters: [
      {
        name: 'warehouse_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['bin_code', 'bin_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/warehouse-storage-bins',
      },
      {
        method: 'post',
        path: '/warehouse-storage-bins',
      },
      {
        method: 'get',
        path: '/warehouse-storage-bins/:binId',
      },
      {
        method: 'patch',
        path: '/warehouse-storage-bins/:binId',
      },
    ],
    columns: [
      'id',
      'warehouse_id',
      'warehouse_code',
      'warehouse_name',
      'bin_code',
      'bin_name',
      'zone_bin_type',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'warehouses',
    base: '/warehouses',
    currentOnly: false,
    create: [
      {
        name: 'alias_source',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'warehouse_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'warehouse_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: true,
        nullable: false,
      },
      {
        name: 'report_site_name',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
    ],
    update: [
      {
        name: 'alias_source',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'warehouse_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'report_site_name',
        kind: 'text',
        required: false,
        nullable: true,
        min: 1,
        max: 100,
      },
      {
        name: 'is_active',
        kind: 'boolean',
        required: false,
        nullable: false,
      },
    ],
    filters: [
      {
        name: 'location_id',
        kind: 'reference',
        required: false,
        nullable: false,
      },
      {
        name: 'active',
        kind: 'enum',
        required: false,
        nullable: false,
        options: ['true', 'false'],
      },
      {
        name: 'q',
        kind: 'text',
        required: false,
        nullable: false,
        max: 200,
      },
    ],
    sort: ['warehouse_code', 'warehouse_name', 'updated_at'],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/warehouses',
      },
      {
        method: 'post',
        path: '/warehouses',
      },
      {
        method: 'get',
        path: '/warehouses/:warehouseId',
      },
      {
        method: 'patch',
        path: '/warehouses/:warehouseId',
      },
    ],
    columns: [
      'id',
      'warehouse_code',
      'alias_source',
      'warehouse_name',
      'location_id',
      'location_code',
      'location_name',
      'report_site_name',
      'is_active',
      'created_at',
      'updated_at',
    ],
  },
  {
    id: 'warning-rules',
    base: '/warning-rules',
    currentOnly: false,
    create: [
      {
        name: 'warning_code',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 50,
      },
      {
        name: 'warning_name',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'condition_text',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
      },
      {
        name: 'responsible_role',
        kind: 'text',
        required: true,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    update: [
      {
        name: 'warning_name',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'applies_to_context',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 200,
      },
      {
        name: 'condition_text',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
      },
      {
        name: 'responsible_role',
        kind: 'text',
        required: false,
        nullable: false,
        min: 1,
        max: 100,
      },
    ],
    filters: [],
    sort: [],
    paginated: true,
    asOf: [],
    history: [],
    routes: [
      {
        method: 'get',
        path: '/warning-rules',
      },
      {
        method: 'post',
        path: '/warning-rules',
      },
      {
        method: 'get',
        path: '/warning-rules/:warningRuleId',
      },
      {
        method: 'patch',
        path: '/warning-rules/:warningRuleId',
      },
      {
        method: 'post',
        path: '/warning-rules/:warningRuleId/confirm',
      },
    ],
    columns: [
      'id',
      'warning_code',
      'warning_name',
      'condition_text',
      'responsible_role',
      'blocking',
      'applies_to_context',
      'created_at',
      'updated_at',
    ],
  },
];
